/**
 * REACT_APP_API_URL 호환:
 * - http://localhost:3001 → 관리자 axios 베이스는 /admin 아래
 * - http://localhost:3001/admin → 이미 관리자 프리픽스까지 포함(기존 .env)
 */
function getTrimmedEnvUrl() {
    const raw = process.env.REACT_APP_API_URL;
    const s = raw != null && String(raw).trim() !== '' ? String(raw).trim().replace(/\/+$/, '') : '';
    return s || 'http://localhost:3001';
}

/** Express 서버 루트 ( /product, /productV2 등 ) */
export function getServerApiRootUrl() {
    const raw = getTrimmedEnvUrl();
    if (/\/admin$/i.test(raw)) return raw.replace(/\/admin$/i, '');
    return raw;
}

export function getAdminApiBaseUrl() {
    const raw = getTrimmedEnvUrl();
    if (/\/admin$/i.test(raw)) return raw;
    return `${raw}/admin`;
}
